import React from 'react';
import './SearchForm.css';

function SearchForm({ 
  query, setQuery, 
  provider, setProvider, 
  providers, 
  dataType, setDataType,
  searchField, setSearchField,
  searchType, setSearchType,
  searchMode, setSearchMode,
  onSearch 
}) {
  const certificateFields = [
    { value: 'auto', label: 'Auto detect' },
    { value: 'ip_address', label: 'IP Address' },
    { value: 'subject_cn', label: 'Subject CN' },
    { value: 'issuer_dn', label: 'Issuer DN' },
    { value: 'issuer_ou', label: 'Issuer OU' },
    { value: 'fingerprint_sha1', label: 'Fingerprint SHA1' },
    { value: 'fingerprint_sha256', label: 'Fingerprint SHA256' },
  ];

  const b2bsaasFields = [
    { value: 'company_keyword', label: 'Company Keyword' },
    { value: 'url', label: 'URL' },
    { value: 'saas_platform', label: 'SaaS Platform' },
  ];

  const currentFields = searchType === 'certificates' ? certificateFields : b2bsaasFields;

  // Сбрасываем searchField при переключении типа поиска
  const handleSearchTypeChange = (newType) => {
    setSearchType(newType);
    if (newType === 'certificates') {
      setSearchField('auto');
    } else {
      setSearchField('company_keyword');
    }
  };

  return (
    <div className="search-form-container">
      {/* Переключатель типа поиска */}
      <div className="search-type-toggle">
        <label>
          <input
            type="radio"
            name="searchType"
            value="certificates"
            checked={searchType === 'certificates'}
            onChange={(e) => handleSearchTypeChange(e.target.value)}
          />
          Certificates
        </label>
        <label>
          <input
            type="radio"
            name="searchType"
            value="b2bsaas"
            checked={searchType === 'b2bsaas'}
            onChange={(e) => handleSearchTypeChange(e.target.value)}
          />
          B2B SaaS
        </label>
      </div>

      <form className="search-form" onSubmit={onSearch}>
        <input
          type="text"
          className="search-input"
          placeholder={searchType === 'certificates' 
            ? "Search by subject CN, fingerprint, or issuer DN..." 
            : "Search by company keyword, URL, or platform..."}
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
        <button type="submit" className="search-button">
          Search
        </button>
        
        {/* Выбор поля для поиска */}
        <select
          className="search-field-select"
          value={searchField}
          onChange={(e) => setSearchField(e.target.value)}
        >
          {currentFields.map((field) => (
            <option key={field.value} value={field.value}>
              {field.label}
            </option>
          ))}
        </select>

        {/* Режим поиска только для certificates */}
        {searchType === 'certificates' && (
          <select
            className="search-mode-select"
            value={searchMode}
            onChange={(e) => setSearchMode(e.target.value)}
          >
            <option value="exact">Exact Match</option>
            <option value="like">Partial Match (LIKE)</option>
          </select>
        )}

        {/* Провайдер только для certificates */}
        {searchType === 'certificates' && (
          <select
            className="provider-select"
            value={provider}
            onChange={(e) => setProvider(e.target.value)}
          >
            <option value="all">All Services</option>
            {providers.map((p) => (
              <option key={p} value={p}>
                {p}
              </option>
            ))}
          </select>
        )}
      </form>

      {/* Тип данных только для certificates */}
      {searchType === 'certificates' && (
        <div className="radio-group">
          <div className="radio-item">
            <input
              type="radio"
              id="actual"
              name="dataType"
              value="actual"
              checked={dataType === 'actual'}
              onChange={(e) => setDataType(e.target.value)}
            />
            <label htmlFor="actual">Actual data</label>
          </div>
          <div className="radio-item">
            <input
              type="radio"
              id="historical"
              name="dataType"
              value="historical"
              checked={dataType === 'historical'}
              onChange={(e) => setDataType(e.target.value)}
              disabled={true}
            />
            <label htmlFor="historical" style={{ opacity: 0.5, cursor: 'not-allowed' }}>Historical data</label>
          </div>
        </div>
      )}
    </div>
  );
}

export default SearchForm;

